// listener to focus on event
// Example: <textarea focus-on="opened" />
// $scope.openSomething = function() {
//     $scope.$broadcast('opened');
// }
//
// Watch scope value
// Example : <input id="email" />
// $scope.autoFocusField = 'email';

angular.module('components.focusOn', [])
    .directive('focusOn', ['$timeout', function ($timeout) {
        return function (scope, elem, attr) {
            var setFocus = function () {
                elem[0].focus();
            };

            if (attr.focusOn === 'auto') {
                setFocus();
            } else {
                scope.$on(attr.focusOn, function (e) {
                    $timeout(setFocus, 1, false);
                });

                scope.$watch('autoFocusField', function (value) {
                    if (value === attr.id) {
                        $timeout(setFocus, 1, false);
                    }
                });
            }
        };
    }]);